export const initialState = {
  recommendedCreneauList: [],
  loadingCreneaux: false,
  isErrorCreneaux: false,
  errorCreneauxMessage: '',
}